export const presetHealthCondition = {
  label: '健康状況から探す',
  list: [
    {
      index: 0,
      label: '１日/2,000kcal制限の方',
      code: 'lim_ene_2000',
    },{
      index: 1,
      label: '１日/1,600kcal制限の方',
      code: 'lim_ene_1600',
    },{
      index: 2,
      label: '１日/塩分5g制限の方',
      code: 'lim_salt_5',
    },{
      index: 3,
      label: '１日/たんぱく質40g制限の方',
      code: 'lim_pro_40',
    },{
      index: 4,
      label: '１日/たんぱく質35g制限の方',
      code: 'lim_pro_35',
    },{
      index: 5,
      label: '食物繊維を多めに摂りたい方',
      code: 'more_fiber',
    },{
      index: 6,
      label: '脂質を控えたい方',
      code: 'lim_lipid',
    },{
      index: 7,
      label: 'カリウムを控えたい方',
      code: 'lim_potassium',
    },{
      index: 8,
      label: 'メタボ予防',
      code: 'metabo',
    },
  ]
}

export const presetItemFeature = {
  label: '商品特徴から探す',
  list: [
    {
      index: 0,
      label: 'ヘルシー食/人気ランキングTOP10',
      code: 'healthy_10',
    },{
      index: 1,
      label: 'ヘルシー食多め/人気ランキングTOP10',
      code: 'healthy_large_10',
    },{
      index: 2,
      label: 'たんぱく質調整食/人気ランキングTOP10',
      code: 'protein_10',
    },{
      index: 3,
      label: '病院の栄養士考案メニュー',
      code: 'hanamaru',
    },
  ]
}

export const presetDiseases = {
  label: '疾病から探す',
  list: [
    {
      index: 0,
      label: '糖尿病',
      code: 'cat1',
    },{
      index: 1,
      label: '高血圧症',
      code: 'cat5',
    },{
      index: 2,
      label: '腎臓病',
      code: 'cat4',
    },{
      index: 3,
      label: '脂質異常症',
      code: 'cat3',
    },{
      index: 4,
      label: '痛風',
      code: 'cat2',
    },{
      index: 5,
      label: '糖尿病性腎症',
      code: 'cat6',
    },
  ]
}